import { Injectable } from '@angular/core';
import { Cabinet_Interface } from 'src/app/Interface/Cabinet_Interface';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DeviceBehfa_Cabinet_Interface } from 'src/app/Interface/DeviceBehfa_Cabinet_Interface';

@Injectable({
  providedIn: 'root'
})
export class CabinetService {

  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<Cabinet_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Cabinet").pipe(
      map(data=>{
        return data as Array<Cabinet_Interface>
      })
    )
  }

  GetActiveList():Observable<Array<Cabinet_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Cabinet/GetActiveList").pipe(
      map(data=>{
        return data as Array<Cabinet_Interface>
      })
    )
  }

  GetWatchViewer():Observable<Array<DeviceBehfa_Cabinet_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Cabinet/GetWatchViewer").pipe(
      map(data=>{
        return data as Array<DeviceBehfa_Cabinet_Interface>
      })
    )
  }

  AddEditCabinet(model: Cabinet_Interface):Observable<Cabinet_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      dsc:model.dsc,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Cabinet/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as Cabinet_Interface
        })
      )

  }



  DeleteCabinet(id:number):Observable<Cabinet_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Cabinet/Delete?id="+id).pipe(
        map(data=>{
          return data as Cabinet_Interface
        })
      )

  }

}
